import React, { useState } from "react";
import { ChevronUp, ChevronDown, Upload } from "lucide-react";

type TopBarProps = {
  onLoadConfig: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onTabChange: (tab: string) => void;
  isExpanded: boolean;
  onToggleExpand: () => void;
  activeTab: string;
  onTabClick: (tab: string) => void;
};

const TopBar: React.FC<TopBarProps> = ({
  onLoadConfig,
  onTabChange,
  isExpanded,
  onToggleExpand,
  activeTab,
  onTabClick,
}) => {
  const handleTabClick = (tab: string) => {
    onTabClick(tab);
    onTabChange(tab);
  };

  return (
    <div
      className={`bg-blue-600 text-white transition-all duration-300 ease-in-out ${
        isExpanded ? "h-auto" : "h-12"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-12">
          <h1 className="text-xl font-bold">Dashboard</h1>
          <button
            onClick={onToggleExpand}
            className="p-2 hover:bg-blue-700 rounded-full transition-colors duration-200"
          >
            {isExpanded ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
          </button>
        </div>
        {isExpanded && (
          <>
            <div className="flex justify-center space-x-4 my-2">
              <button
                onClick={() => handleTabClick("energia")}
                className={`px-4 py-2 rounded-md transition-colors duration-200 ${
                  activeTab === "energia"
                    ? "bg-blue-700 font-bold"
                    : "hover:bg-blue-500"
                }`}
              >
                Energia
              </button>
              <button
                onClick={() => handleTabClick("comunicacao")}
                className={`px-4 py-2 rounded-md transition-colors duration-200 ${
                  activeTab === "comunicacao"
                    ? "bg-blue-700 font-bold"
                    : "hover:bg-blue-500"
                }`}
              >
                Comunicação
              </button>
              <button
                onClick={() => handleTabClick("geracao")}
                className={`px-4 py-2 rounded-md transition-colors duration-200 ${
                  activeTab === "geracao"
                    ? "bg-blue-700 font-bold"
                    : "hover:bg-blue-500"
                }`}
              >
                Geração
              </button>
            </div>
            {activeTab !== "geracao" && (
              <div className="flex justify-center my-2">
                <label
                  htmlFor="load-config"
                  className="cursor-pointer px-4 py-2 bg-white text-blue-600 rounded-md hover:bg-gray-100 transition-colors duration-200 flex items-center"
                >
                  <Upload size={18} className="mr-2" />
                  Carregar Dados (
                  {activeTab === "energia" ? "Energia" : "Comunicação"})
                </label>
                <input
                  id="load-config"
                  type="file"
                  accept=".json"
                  className="hidden"
                  onChange={onLoadConfig}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TopBar;
